import Cookies from 'js-cookie';
import { themeConfig } from '@libs/@core/constants/config';
import { COOKIE_KEYS } from '@libs/@core/constants/key';
export var getSettingsFromCookie = function () {
    var _a;
    var cookieName = themeConfig.settingsCookieName;
    return JSON.parse(((_a = Cookies.get(cookieName)) === null || _a === void 0 ? void 0 : _a.value) || '{}');
};
export var setAccessTokenCookie = function (accessToken) {
    Cookies.set(COOKIE_KEYS.ACCESS_TOKEN, accessToken, {
        expires: 7, // 7 days
        sameSite: 'strict'
    });
};
export var getAccessTokenCookie = function () {
    return Cookies.get(COOKIE_KEYS.ACCESS_TOKEN);
};
export var clearAccessTokenCookie = function () {
    Cookies.remove(COOKIE_KEYS.ACCESS_TOKEN);
};
export var checkParamsObject = function (params) {
    var obj = {};
    for (var key in params) {
        if (params[key]) {
            obj[key] = params[key];
        }
    }
    return obj;
};
